import * as Components from './components';
import * as Views from './views';
import { IModule } from '@/types/module.types';
import { routes } from './router';

export const Dashboard: IModule = { Components, routes, Views };
